import { env } from '@/config/env';
import { notification } from '@/lib/notifications';
import { saveBlobAs } from './download';
import { getTranslation } from './i18n';

// The public file stream; /api/v1/resources is mounted without auth, so a viewer can embed it.
export const fileStreamUrl = (fileId) =>
  fileId == null ? '' : `${env.apiBaseUrl}/resources/file/${fileId}`;

// Fetched as a Blob so the saved file keeps its name — a cross-origin `download` attribute is ignored.
export const downloadFile = async (fileId, filename) => {
  const response = await fetch(fileStreamUrl(fileId));
  if (!response.ok) throw new Error(`File ${fileId} could not be downloaded (${response.status})`);
  saveBlobAs(await response.blob(), filename);
};

// A stored file by id, or a just-picked File before it is uploaded — both open in a new tab.
export const openFile = (file) => {
  const url = file instanceof Blob ? URL.createObjectURL(file) : fileStreamUrl(file);
  window.open(url, '_blank', 'noopener');
};

// An attachments-table row's Download — `{ fileId, name }`; a failure is reported, never thrown.
export const downloadAttachment = ({ fileId, name }) =>
  downloadFile(fileId, name).catch(() =>
    notification.error(getTranslation('ATTACHMENT_DOWNLOAD_ERROR', { name })),
  );
